import $ from 'jquery';
import simpleParallax from 'simple-parallax-js';

export default class Parallax {
    constructor() {
        if($('.js-parallax').length) {
            $('.js-parallax').each(function() {
                const $this = $(this);

                const parallax = new simpleParallax($this[0]);
            });
        };
    };
};
